<template>
    <div>
        <b-modal
            ref="modalEdit"
            hide-footer
            :title="titleModal"
            size="md"
            no-close-on-backdrop
            hide-header-close
            hide-header
        >
            <div class="title-modal">
                <div class="title-text-modal">{{ titleModal }}</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModal(true)"
                >
                    <xIcon/>
                </div>
            </div>
            <div class="modal-edicao d-block mb-3 modal-edicao-label mt-6">
                <b-row>
                    <b-col cols="12" class="d-block text-parcela">
                        <span class="label-conta">Categoria da Conta</span>
                        <b-form-input
                            name="nome_categoria"
                            class="modal-edicao-input"
                            type="text"
                            v-model="categoryExpenseSelected.description"
                            autocomplete="off"
                            placeholder="Digite o nome do categoria de transação"
                            v-validate="'required|maxLength:50'"
                            :state="validateState('nome_categoria')"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" class="d-block text-parcela">
                        <span class="label-conta">Permite Renda</span>
                        <ToggleSwitch
                            name="category-income"
                            class="toggle-categoria"
                            :value="categoryExpenseSelected.income"
                            @toggle="_ => changeToggle('income')"
                        />
                    </b-col>
                </b-row>
            </div>
            <b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModal(true)">Cancelar</b-button>
            <b-button class="mt-3 float-left btn-modal btn-limpar" @click="cleanModal()">Limpar</b-button>
            <b-button
                class="mt-3 ml-1 float-right btn-modal btn-salvar"
                @click="saveRecord"
                :disabled="invalidForm || saving"
            >
                Salvar
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { CategoryExpensesService } from "../../services/categoryExpenses";
	import emitter from "@/eventBus.js";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import { mapState } from "vuex";

	export default {
		components: {
			ToggleSwitch
		},

		props: {
			categoryExpenseData: {
				type: Object,
				required: false
			},
			name: {
				type: String,
				required: false
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				titleModal: "",
				categoryExpenseSelected: {
					idCategoryExpense: "",
					description: "",
					income: false
				},
				categoryExpensesService: new CategoryExpensesService(),
				loading: true,
				noEditCategoryExpense: false,
				invalidForm: true,
				saving: false
			};
		},

		computed: mapState(["category"]),

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			this.showCategoryExpense();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			showCategoryExpense () {
				this.invalidForm = true;
				const {
					idCategoryExpense = null,
					description = "",
					income = false
				} = this.categoryExpenseData;

				if (!idCategoryExpense) {
					this.categoryExpenseSelected.description = this.name;
					this.titleModal = "Cadastrar Nova Categoria de Contas";
					this.noEditAccount = true;
				} else {
					this.categoryExpenseSelected.description = description;
					this.titleModal = "Editar Categoria de Contas";
					this.noEditAccount = false;
				}

				this.categoryExpenseSelected.idCategoryExpense = idCategoryExpense;
				this.categoryExpenseSelected.income = income;
				this.$refs.modalEdit.show();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			closeModal () {
				this.$refs.modalEdit.hide();
				this.cleanModal();
				this.categoryExpenseSelected.idCategoryExpense = null;
				this.saving = false;
				this.invalidForm = true;
				this.$emit("closeModal");
			},

			cleanModal () {
				this.categoryExpenseSelected.description = "";
				this.categoryExpenseSelected.income = false;
			},

			async saveRecord () {
				const invalidFields = await this.validateModal();
				if (invalidFields) {
					await this.$swal({
						title: "Formulário Inválido",
						text: "Existe informação sem preencher!",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return;
				}

				if (await this.recordExist()) {
					return;
				}

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};
				const payload = {
					description: this.categoryExpenseSelected.description,
					income: this.categoryExpenseSelected.income
				};

				if (this.categoryExpenseSelected.idCategoryExpense)
					payload.idCategoryExpense = this.categoryExpenseSelected.idCategoryExpense;

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						const newCategoryExpense = await this.categoryExpensesService.upsertCategoryExpense({payload});

						this.$emit("findCategoryExpenses", true);
						this.$emit("newCategoryExpense", newCategoryExpense);
						emitter.emit("reloadCategory", { reload: true });
						this.closeModal();

						return {
							title: "Sucesso!",
							body: "Categoria de transação salva com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar a categoria de transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async validateModal () {
				const validationFields = Object.keys(this.veeFields);
				if (!validationFields.length)
					return true;

				const validations = validationFields.reduce((acc, ref) => {
					if (this.veeFields[ref] && this.veeFields[ref].invalid)
						return [...acc, this.veeFields[ref].invalid];

					return acc;
				}, []);

				const invalidFields = validations.filter(field => field);
				return Boolean(invalidFields && invalidFields.length);
			},

			changeToggle (key) {
				this.categoryExpenseSelected[key] = !this.categoryExpenseSelected[key];
			},

			async recordExist () {
				const recordExist = this.category.find(c => c.text === this.categoryExpenseSelected.description && this.categoryExpenseSelected.idCategoryExpense !== c.value);
				if (recordExist) {
					await this.$swal({
						title: "Registro já existe",
						text: "Não é possível criar o registro, altere o nome e tente novamente.",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return true;
				}
				return false;
			}
		}
	};
</script>